/* eslint-disable */
export default {
  logging: 'Kirjataan lokiin...',
  logCall: 'Kirjaa puhelu lokiin',
  editLog: 'Muokkaa lokia',
  select: 'Valitse tallenne',
  OnHold: 'Pidossa',
  Ringing: 'Soitetaan',
  CallConnected: 'Puhelu yhdistetty',
  unknownUser: 'Tuntematon käyttäjä',
  unknownNumber: 'Nimetön',
  unavailable: 'Ei käytettävissä',
  viewDetails: 'Näytä tiedot',
  conferenceCall: 'Neuvottelupuhelu',
  callerId: 'Soittajatunnus',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
